<template>
    <div>
        <ul>
        <li>
            Esses Termos de Serviço aplicam-se a ferramenta web PORTAL AMBIENTAL (disponível em
            https://licenciamento.ima.al.gov.br) instituída pela Portaria IMA/AL 44/2018 que torna
            obrigatória sua utilização como único meio de entrada de documentos para abertura de
            processos de autorização e licenciamento ambiental junto ao Instituto do Meio Ambiente
            – IMA/AL.
        </li>
        </ul>
        <ul>
        <li class="mt-2 mb-2"><b>1. Aceitação dos Termos</b></li>
        <li>
            <b>1.1</b> Para usar os Serviços, o usuário deverá primeiro concordar com os Termos.
            Não é permitido o uso dos Serviços por parte do usuário se ele não aceitar os Termos.
        </li>
        <li>
            <b>1.2</b> O usuário pode aceitar os Termos:
        </li>
        <ul>
            <li>
            <b>(A)</b> clicando para aceitar ou concordar, no caso de essa opção ser
            disponibilizada pelo IMA na interface do usuário do Serviço; ou
            </li>
            <li>
            <b>(B)</b> usando efetivamente os Serviços. Nesse caso, o usuário compreende e
            aceita que o IMA/AL considerará o uso dos Serviços uma aceitação dos Termos a
            partir desse momento.
            </li>
        </ul>
        </ul>
        <ul>
        <li class="mt-4 mb-2"><b>2. Termos de Uso</b></li>
        <li>
            <b>2.1.</b> O usuário concorda em usar os Serviços somente para os fins permitidos:
            (a) pelos Termos; e (b) pelas leis, normas, práticas ou diretrizes geralmente aceitas
            nas jurisdições relevantes e aplicáveis.
        </li>
        <li>
            <b>2.2.</b> O usuário concorda em não participar de atividades que interfiram ou
            interrompam o funcionamento dos Serviços (ou servidores e redes conectados aos
            Serviços).
        </li>
        <li>
            <b>2.3.</b> O usuário concorda que será o único responsável por qualquer violação
            das suas obrigações no que diz respeito aos Termos e pelas conseqüências resultantes
            dessa violação.
        </li>
        <li>
            <b>2.4.</b> O envio de documentos, acompanhamento de status e notificações dos
            processos de autorização e licenciamento ambiental são integralmente online por
            meio do PORTAL AMBIENTAL, sem a necessidade de apresentação de documentos físicos.
        </li>
        <li>
            <b>2.5.</b> O procedimento no PORTAL AMBIENTAL, consiste nas seguintes 06 (seis)
            etapas:
            <ul>
            <li>
                <b>Etapa 1 –</b> Cadastro do empreendedor/empreendimento;
            </li>
            <li>
                <b>Etapa 2 –</b> Enquadramento e detalhamento da tipologia;
            </li>
            <li>
                <b>Etapa 3 –</b> Indicação do tipo de documento e/ou fase de licenciamento
                requerida;
            </li>
            <li>
                <b>Etapa 4 -</b> Emissão dos documentos FCA (Formulário de Caracterização
                Ambiental) e DAR (Documento de Arrecadação de Receitas);
            </li>
            <li>
                <b>Etapa 5 –</b> Envio de documentação digital de acordo com checklist exigido.
            </li>
            <li>
                <b>Etapa 6 –</b> Aprovação da documentação e autuação do processo de
                licenciamento.
            </li>
            </ul>
        </li>
        <li>
            <b>2.6.</b> A autuação do processo de autorização e licenciamento ambiental,
            bem como a indicação do número de processo, só será efetuada após cumprimento integral
            das etapas previstas no item 2.5.
        </li>
        <li>
            <b>2.7.</b> O processo de licenciamento junto ao órgão ambiental, IMA, seguirá o
            disposto na Lei Estadual 6787/2006, Resolução CONAMA 237/97 e Resolução CEPRAM
            10/2018 que estabelece os procedimentos, prazos, documentos, estudos ambientais,
            roteiros, entre outras informações pertinentes.
        </li>
        <li>
            <b>2.8.</b> O Documento de Arrecadação de Receita – DAR é gerado de acordo com a
            Lei Estadual 6787/2006 e suas atualizações que definem o cálculo da Taxa de Prestação
            de Serviços Ambientais.
        </li>
        <li>
            <b>2.9.</b> De acordo com a Instrução Normativa IBAMA n° 21, de 24 de dezembro
            de 2014, em observância dos arts. 35 e 36 da Lei nº 12.651, de 25 de maio de 2012
            as solicitações de emissão de autorizações de Supressão de Vegetação, deverão utilizar
            o SINAFLOR.
        </li>
        <li>
            <b>2.10.</b> A Anotação de Responsabilidade Técnica – ART emitida pelos profissionais
            é obrigatória para os serviços sujeitos à fiscalização dos seus respectivos conselhos
            de classe. O usuário compreende que a responsabilidade integral pelo conteúdo das
            informações e documentos enviados (tais como requerimentos, publicações, projetos,
            planos, estudos ambientais, dentre outros) é do profissional que deu origem a esse
            conteúdo.
        </li>
        <li>
            <b>2.11.</b> O IMA/AL não assumirá qualquer responsabilidade pelo não cumprimento
            de contratos firmados entre o interessado, seus consultor(es) e/ou projetista(s).
        </li>

        <li>
            <b>2.12.</b> A janela de Chat disponível no PORTAL AMBIENTAL funciona apenas nos
            dias e horários de expediente, ou seja, de segunda a sexta-feira de 08:00 às 14:00hrs
            (exceto feriados), tendo as seguintes orientações aos usuários:
            <ul>
            <li>
                <b>i.</b> Abertura de Chat que não apresente e/ou indique informações
                suficientemente CLARAS acerca do assunto a ser tratado serão CANCELADAS a
                qualquer momento;
            </li>
            <li>
                <b>ii.</b> Fica terminantemente proibida a solicitação de orientação ou
                consultoria em relação a elaboração de estudos ambientais, projetos e planos.
                Para estes fins o interessado deve contratar um profissional legalmente
                habilitado;
            </li>
            <li>
                <b>iii.</b> Fica terminantemente proibida a solicitação para aprovação e
                priorização da análise de documentos objetivando &quot;cobrar&quot; providências e
                &quot;status&quot; da abertura dos processos junto aos responsáveis;
            </li>
            <li>
                <b>iv.</b> O atendimento prestado tem como objetivo ÚNICO e EXCLUSIVO
                a prestação de informações relativas a exigências técnicas e de procedimentos
                internos do Órgão;
            </li>
            <li>
                <b>v.</b> Durante o agendamento não será aceito anexar e/ou complementar
                documentos do processo, os quais devem ser realizados por meio do protocolo
                oficial do órgão.
            </li>
            </ul>
        </li>
        <li>
            <b>2.13.</b> O Software usado pelo usuário pode, ocasionalmente, sofrer
            atualizações. Essas atualizações são concebidas para melhorar, aperfeiçoar e
            desenvolver os Serviços e podem ser apresentadas sob a forma de correções de
            erros, funções aprimoradas, novos módulos de software e versões completamente novas.
        </li>
        <li>
            <b>2.14.</b> O IMA poderá alterar/revisar periodicamente os Termos de Uso e
            quando essas alterações forem realizadas o usuário compreende e concorda que, se
            utilizar os Serviços após a data de alteração dos Termos de Uso, o IMA considerará
            essa utilização como uma aceitação dos Termos de Uso atualizados.
        </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'LegalTermsText',
};
</script>

<style scoped lang="scss">
  ul{
    list-style: none;
  }
  ul li {
    margin: 10px 0;
  }
</style>
